import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import api from 'atg/api/API';
import BetConfig from 'atg/api/BetConfig';
import BetKey from 'atg/api/BetKey';
import { createAtgBetParams } from 'shared/proptypes';
import {
  hideLoader,
  showAtgBetConfigDialog,
  showLoader,
} from 'shared/redux/actions';

import Dialogs from './Dialogs';

const CreateBetContainer = ({ betParams, jokerController }) => {
  const history = useHistory();

  const dispatch = useDispatch();

  useEffect(() => {
    if (betParams.hasOwnProperty('tipBetId')) {
      api.loadBetTip(betParams.tipBetId, betId => {
        if (betId) {
          history.replace(`/trav/${betId}`);
        }
      });
    } else {
      const betKey = new BetKey(betParams);
      api.loadBetKeyInfo(betKey, betKeyInfo => {
        dispatch(
          showAtgBetConfigDialog({
            betKey,
            betKeyInfo,
            betConfig: new BetConfig(),
            isNewGame: true,
            onConfirmNewConfig: (newBetConfig, closeCallback) => {
              dispatch(showLoader('main-loader-new-bet-heading'));
              api.createBet(
                betId => {
                  if (betId) {
                    history.replace(`/trav/${betId}`, {
                      hasBetInformation: true,
                    });
                  } else {
                    dispatch(hideLoader());
                  }
                  closeCallback();
                },
                betKey,
                newBetConfig,
              );
            },
          }),
        );
      });
    }
  }, [betParams, history, jokerController, dispatch]);

  return <Dialogs jokerController={jokerController} />;
};

CreateBetContainer.propTypes = {
  betParams: createAtgBetParams.isRequired,
  jokerController: PropTypes.object.isRequired,
};

export default CreateBetContainer;
